import type * as THREE from 'three'

/**
 * 校验拾取查询的最小射线距离。
 *
 * @param minDistance - 从原始射线起点沿归一化方向计算的世界坐标距离
 * @param parameterName - 错误信息中的参数名
 */
export function assertValidPickMinDistance(
  minDistance: number | undefined,
  parameterName = 'minDistance'
): void {
  if (minDistance === undefined) {
    return
  }
  if (!Number.isFinite(minDistance) || minDistance < 0) {
    throw new RangeError(`${parameterName} 必须是有限且不小于零的数`)
  }
}

/**
 * 计算世界点在射线归一化方向上的有符号距离。
 *
 * @param ray - 原始世界坐标射线
 * @param point - 待测世界点
 * @returns 点相对射线起点的有符号世界坐标距离
 */
export function getPickRayDistance(ray: THREE.Ray, point: THREE.Vector3): number {
  const directionLength = ray.direction.length()
  if (directionLength <= Number.EPSILON) {
    return Number.NEGATIVE_INFINITY
  }
  return point.clone().sub(ray.origin).dot(ray.direction) / directionLength
}

/**
 * 判断世界点是否位于可拾取最小射线距离之上。
 *
 * @param ray - 原始世界坐标射线
 * @param point - 待测世界点
 * @param minDistance - 可选最小距离
 * @returns 未设置阈值或点位于包含边界之后时返回 true
 */
export function isPickPointAtOrBeyondMinDistance(
  ray: THREE.Ray,
  point: THREE.Vector3,
  minDistance: number | undefined
): boolean {
  return minDistance === undefined || getPickRayDistance(ray, point) >= minDistance
}
